import React, { useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import PasswordField from "../passwords/PasswordField";
import PasswordRequirements from "../passwords/PasswordRequirements";
import usePasswordInputGuard from "../passwords/usePasswordInputGuard";
import { isValidNewPassword } from "../../utils/passwordPolicy";

const CardResetPassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { search } = useLocation();
  const { changePassword, handlePasswordPaste } = usePasswordInputGuard();

  const resetPassword = async (event) => {
    event.preventDefault();
    if (isSubmitting) return;
    if (password !== confirmPassword) {
      enqueueSnackbar("Les mots de passe ne correspondent pas.", { variant: "error" });
      return;
    }
    if (!isValidNewPassword(password)) {
      enqueueSnackbar("Le mot de passe ne correspond pas aux critères requis.", { variant: "error" });
      return;
    }
    setIsSubmitting(true);
    try {
      const response = await axios({
        method: "post",
        url: `${API_BASE_URL}/users/changePasswordReset`,
        headers: {
          "Content-Type": "text/plain",
          Authorization: new URLSearchParams(search).get("token"),
        },
        data: { new_password: password },
      });
      if (response.status !== 200 || response.data == null) {
        throw new Error("Password reset failed");
      }
      enqueueSnackbar("Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.", { variant: "success" });
      window.location.href = "/login";
    } catch {
      enqueueSnackbar("Une erreur est survenue. Veuillez réessayer ou demander un nouveau lien depuis la page de connexion.", { variant: "error" });
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderField = ({ id, label, placeholder, value, setter, visibilityLabel }) => (
    <PasswordField
      id={id}
      label={label}
      placeholder={placeholder}
      value={value}
      disabled={isSubmitting}
      describedBy={password ? "password-reset-rules" : undefined}
      visibilityLabel={visibilityLabel}
      onChange={(nextValue) => changePassword(setter, nextValue)}
      onPaste={handlePasswordPaste}
    />
  );

  return (
    <form className="password-reset-form" onSubmit={resetPassword} aria-busy={isSubmitting}>
      <PasswordRequirements password={password} id="password-reset-rules" />
      {renderField({
        id: "new-password", label: "Nouveau mot de passe", placeholder: "Nouveau mot de passe",
        value: password, setter: setPassword, visibilityLabel: "le nouveau mot de passe",
      })}
      {renderField({
        id: "confirm-password", label: "Confirmer le nouveau mot de passe", placeholder: "Confirmer nouveau mot de passe",
        value: confirmPassword, setter: setConfirmPassword, visibilityLabel: "la confirmation du mot de passe",
      })}
      <button type="submit" className="password-reset-button" disabled={isSubmitting}>
        {isSubmitting ? "Réinitialisation en cours…" : "Réinitialiser le mot de passe"}
      </button>
    </form>
  );
};

export default CardResetPassword;
